import gql from 'graphql-tag';

export default gql`
  mutation delete($type: String, $id: String) {
    delete(type: $type, id: $id)
  }
`;
